import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('chat', 'send-message');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'chat',
  type: 'post',
  slug: ['messages'],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sendMessage.js